export default __webpack_public_path__ + "e0f05f0df915245e2d5cc72ed9b19101.png";